import React, {useState} from 'react';
import { useRoutes } from '../../../AppSystem/Routing/useRoutes';
import { ChangeLink } from './ChangeLink';
import {Link, useLocation} from "react-router-dom";
import {CheckMobile} from "../../../AppSystem/Helpers/CheckMobile";
import {SaveLocalStorage} from "../../../Common/Helpers/SaveLocalStorage";
import {LoadLocalStorage} from "../../../Common/Helpers/LoadLocalStorage";
import {CustomReload} from "../../../AppSystem/Helpers/CustomReload";
import $ from 'jquery';

/////////////////// IMPORTANT: WAS CHANGED "index" FOR "route.name.trim()"

const Sidebar = ({ toggle, /*onMenuClick*/ }) => {
  const routes = useRoutes();
  const location = useLocation();
  const [activePath, setActivePath] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const windowWidth = CheckMobile(1025);
  const [isHovered, setIsHovered] = useState(false);

  const isRouteActive = (path) => {
    if (!path) return false;
    const { pathname } = location;
    return pathname === path || pathname.startsWith(`${path}/`);
  };

  // const [activeItem, setActiveItem] = useState(null); //para ver que li esta activo
  const handleItemClick = (index) => {
    if(activePath === `dropdown${index}`){
      setIsExpanded(!isExpanded);
    } else {
      setIsExpanded(true);
    }
    // setActiveItem(index);
  };

  /*
  const handleMouseEnter = classValue => {
    setIsHovered(true);
    const element = document.querySelector(`.${classValue}`);
    if (toggle === true) {
      element.current.classList.add('d-block');
    }
  };

  const handleMouseLeave = classValue => {
    setIsHovered(false);
    const element = document.querySelector(`.${classValue}`);
    if (toggle === true) {
      element.current.classList.remove('d-block');
    }

  };
   */

  const changeName = newTitle => {
    // onMenuClick(newTitle);
   // SaveLocalStorage('headerTitle', newTitle);
    localStorage.removeItem('currentPage');
    localStorage.removeItem('itemsPerPage');
  };

  const handleLinkClick = link => {
    setActivePath(link);
  };

  // EXECUTE ONCHANGE SEARCH INPUT (SIMULATE CLEAR)
  // IMPORTANT: THIS IS A TEMPORARY SOLUTION, IT IS NOT THE BEST WAY TO DO IT. ONLY WORKING IN LIST PAGES
  const clearSearchCriteria = (label) => {
    const search = LoadLocalStorage("search");
    if (search) {
      localStorage.removeItem('search');
      const searchCriteria = document.getElementById('searchCriteria');
      if (searchCriteria) {
        const title = LoadLocalStorage("headerTitle");
        if (title && title === label) {
          CustomReload();
        }
      }
    }
  };

  //functions for shortcutCreate true
  // const [hovered, setHovered] = useState('');
  // const handleMouseEnter2 = path => {
  //   setHovered(path);
  // };
  // const handleMouseLeave2 = () => {
  //   setHovered('');
  // };

  return (
    <>
      <ul className="metismenu list-unstyled" id="side-menu">
        {routes.map((route, index) => {
          const routeName = (route?.name ?? '').toString().trim();
          const routeKeyBase = (route?.path ?? `${routeName}-${index}`).toString();
          const safeRouteKey = routeKeyBase.replace(/[^a-zA-Z0-9_-]/g, '_');
          const dropdownId = `dropdown${safeRouteKey}`;

          return (
          route.hideInMenu === undefined || (route.hideInMenu !== undefined && route.hideInMenu !== true) ? (
            // Dropdown
            route.dropdown !== undefined && route.dropdown === true ? (
              <React.Fragment key={`menuTitle-${safeRouteKey}`}>
                {/* Title if has*/}
                {route.title !== undefined && route.title !== null ? (
                  <li className="menu-title" data-key="t-menu" key={`dropdown-${safeRouteKey}`}>
                    {toggle === true ? '' : route.title}
                  </li>
                ) : (
                  ''
                )}

                {Array.isArray(route.subs) && route.subs.length > 0 ? (
                    <li className={`dropdown`} 
                        id={`liId${safeRouteKey}`}
                        key={`dropdownActive-${safeRouteKey}`}
                        onMouseEnter={() => {
                          if(toggle === true && !isHovered){
                            setIsHovered(true);
                            handleLinkClick(dropdownId);
                          }
                        }}
                        onMouseLeave={() => {
                          if(toggle === true ){
                            setIsHovered(false);
                          }
                        }}
                        onClick={() => {
                          if(toggle === true ){
                            setIsHovered(!isHovered);
                          }
                        }}
                    >
                      <Link
                          to={`#${dropdownId}`}
                          className={`${isExpanded && activePath === dropdownId ? 'has-arrow-close' : 'has-arrow'} ${toggle === true && !windowWidth ? ' has-arrow-color' : ''}`} // d-flex justify-content-center
                          role="button"
                          data-bs-toggle="collapse"
                          aria-expanded="false"
                          onClick={() => {
                            handleItemClick(safeRouteKey);
                            handleLinkClick(dropdownId);
                          }}
                      >
                        <i className={`${route.icon} fs-5`} />

                        <span className="menu-item ">{toggle === true && !windowWidth ? '' : route.name}</span>
                      </Link>
                      <ul
                          className={`${toggle === true && !windowWidth ? 'sub-menu-especial' : 'sub-menu'} ${isExpanded === true && activePath === dropdownId ? (toggle === false ? '' :'collapse' ) : 'collapse'}   ${isHovered && activePath === dropdownId ? 'd-block' : ''} ${dropdownId}`}
                          id={dropdownId}
                      >
                        {toggle === true && !windowWidth? <li className="title-menu d-block">{route.name}</li> : ''}
                        {Array.isArray(route.subs)
                          ? route.subs.map((item, index2) => {
                              return (
                                  <li className={`border-warning ${location.pathname === item.path ? 'active' : ''}`} key={`${item.label}dropdownOptions${index2}`}>
                                    <Link
                                        to={item.path}
                                        onClick={() => {
                                          clearSearchCriteria(item.label);
                                          changeName(item.label);

                                          // REMOVE LOCAL STORAGE FROM INTERNAL TRANSACTION
                                          if (window.location.href.includes("internal-transaction") === false) {
                                            localStorage.removeItem('originOrgId');
                                            localStorage.removeItem('message');
                                          }

                                          if (windowWidth) {
                                            $('#closeHamburger').click();
                                          }
                                        }}
                                    >
                                      {item.icon ? <i className={item.icon} /> : ''}
                                      <span className="px-2 border-warning">{item.label}</span>
                                    </Link>
                                  </li>
                              );
                            })
                            : ''}
                      </ul>
                    </li>

                ) : ''}

              </React.Fragment>
            ) : (
              // Normal link
              <React.Fragment key={`normalFragment-${safeRouteKey}`}>
                {/* Title if has*/}
                {route.title !== undefined && route.title !== null ? (
                  <li className="menu-title" data-key="t-menu" key={`normal-${safeRouteKey}`}>
                    {toggle === true && !windowWidth ? '' : route.title}
                  </li>
                ) : (
                  ''
                )}
                <li key={`normalActive-${safeRouteKey}`} className={isRouteActive(route.path) ? 'active' : ''}>
                  <ChangeLink
                    // mouseEnter={() => {
                    //   handleMouseEnter2(route.path);
                    // }}
                    // mouseLeave={handleMouseLeave2}
                      toggle={toggle}
                    icon={route.icon}
                    link={route.path}
                    onClick={() => {
                      clearSearchCriteria(route.name);
                      changeName(route.name);

                      // REMOVE LOCAL STORAGE FROM INTERNAL TRANSACTION
                      if (window.location.href.includes("internal-transaction") === false) {
                        localStorage.removeItem('originOrgId');
                        localStorage.removeItem('message');
                      }

                      handleLinkClick(route.path);
                      if (windowWidth) {
                        $('#closeHamburger').click();
                      }
                    }}
                    label={toggle === true && !windowWidth ? '' : route.name}
                    //condition={hovered}
                    shortcutCreate={false}
                  />
                </li>
              </React.Fragment>
            )
          ) : (
            ''
          )
        );
      })}
      </ul>
    </>
  );
};

export default Sidebar;